/*
 * Module for DROP Account - Index
 */
rs.module("content/participant/drop/account/index",

    [ /* dependencies */ ],

    function () {

        function initialize(jsSelectors, cssSelectors) {

            var dropAccountForm = $.js(jsSelectors.dropAccountForm);

            var historyContainer = dropAccountForm.js(jsSelectors.historyContainer);
            var historyPanel = dropAccountForm.js(jsSelectors.historyPanel);

            // show/hide DROP account status history on hover with intent
            historyContainer.hoverIntent({
                handlerOver: function (event) {
                    historyPanel.toggleClass(cssSelectors.visible, true);
                },
                handlerOut: function (event) {
                    historyPanel.toggleClass(cssSelectors.visible, false);
                },
                hoverOutDelay: 400
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);